/**
 * Model reprezentujący publiczną wizytówkę kliniki weterynaryjnej.
 * Używany do renderowania widoku "O nas" w aplikacji mobilnej.
 */
export class VetClinicInfoData {

  /** Wewnętrzny vetcode kliniki. */
  public vetcodeId: number;

  /** Opis placówki. */
  public about: string;

  /** * Płaska lista (tablica stringów) oferowanych usług.
   */
  public services: string[];

  /** Zespół medyczny placówki (lekkie obiekty DTO lekarzy). */
  public team: VetDoctorData[];

  /** Publiczna galeria zdjęć. */
  public gallery: Photo[];

  /** Skrót kryptograficzny (Hash) aktualnego stanu obiektu.
   */
  public hash: string;

}

/**
 * Odchudzony model Lekarza Weterynarii.
 * Zawiera wyłącznie te dane, które pacjent powinien zobaczyć na profilu
 * publicznym, całkowicie ukrywając logikę kalendarzy, limitów i blokad (WorkHours).
 */
export class VetDoctorData {

  /** Pełne imię, nazwisko i tytuł naukowy. */
  public name: string;

  /** Skrócona forma do widoków UI. */
  public shortName: string;

  /** Opis doświadczenia lekarza. */
  public description: string;

  /** Główny numeryczny identyfikator lekarza (Work Hour Object ID).
   * Funkcjonalnie pełni rolę `doctorId`. Wykorzystywany przez metody pomocnicze
   * (np. getVetDoctor) do precyzyjnego wyszukiwania i wyciągania obiektu
   * konkretnego specjalisty z tablicy zespołu (team) danej kliniki.
   */
  public whObjId: number;

  /** Kolejność wyświetlania na liście zespołu. */
  public orderIndex: number;

  /** Miniaturka zdjęcia profilowego w formacie gotowym do użycia w tagu <img>. */
  public photo: Photo;

  /** Pełnowymiarowe zdjęcie wyświetlane po wejściu w szczegóły profilu lekarza. */
  public largePhoto: Photo;

}

/**
 * Czysty model (DTO) reprezentujący zdjęcie gotowe do wyświetlenia na frontendzie.
 * Różni się od backendowego VImage tym, że ukrywa strukturę folderów UUID
 * i od razu podaje frontendowi gotowe, sklejone adresy URL.
 */
export class Photo {

  /** Bezwzględny adres URL do zdjęcia.
   */
  public fullUrlPath: string;

  /** Względna ścieżka do zdjęcia.
   */
  public urlPath: string;

  /** Oryginalna nazwa pliku. */
  public filename: string;

  /** Zserializowane metadane o dostępnych wersjach zdjęcia. */
  public versions: string;

}
